var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51925 11.0247C1.56302 11.2215 1.60502 11.4117 1.64561 11.5955C1.87984 12.6562 2.06754 13.5061 2.28076 14.2104C2.52963 15.0325 2.7886 15.5651 3.12206 15.9363C3.75998 16.6465 4.88642 17 7.79167 17C10.6969 17 11.8233 16.6465 12.4613 15.9363C12.7947 15.5651 13.0537 15.0325 13.3026 14.2104C13.5158 13.5061 13.7035 12.6562 13.9377 11.5956C13.9783 11.4117 14.0203 11.2216 14.0641 11.0247C14.6308 8.47622 14.2546 7.21675 13.4134 6.51262C12.9567 6.13033 12.2861 5.83875 11.3357 5.64735C10.3874 5.45636 9.21169 5.375 7.79167 5.375C6.37164 5.375 5.19596 5.45636 4.24765 5.64735C3.29726 5.83875 2.62664 6.13033 2.16993 6.51262C1.32871 7.21675 0.952567 8.47623 1.51925 11.0247Z",
    stroke: "#CE2E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79167 9V13.375M4.875 9V13.375M10.7083 9V13.375",
    stroke: "#CE2E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2.4375H6.33333V1.25C6.33333 0.697715 6.78105 0.25 7.33333 0.25H8.25C8.80228 0.25 9.25 0.697715 9.25 1.25V2.4375Z",
    fill: "#CE2E64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22949 3.89583C2.23911 3.24769 4.42661 2.4375 7.79199 2.4375C11.1574 2.4375 13.2776 3.24769 14.3545 3.89583",
    stroke: "#CE2E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.8d1d10a4a78b0b5d4418b82273c69380.svg";
export { ForwardRef as ReactComponent };